import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Post from '../components/Post'
import firebase from 'firebase'
import moment from 'moment'
// import AdSense from 'react-adsense'

export default class Posts extends Component {
	constructor(props) {
		super(props);
	}
	
  render() {
		console.log('this.props.posts ', this.props.posts);
    return (
			<ul className="jobs">
				{this.props.posts.map((post, i) => <Post key={i} post={post} onClick={this.props.onClick}/>)}
			</ul>
    )
  }
}

Posts.propTypes = {
  posts: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired
}


// WEBPACK FOOTER //
// ./src/components/Posts.js